<template>
	<div class="content">
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
				<stats-card data-background-color="orange">
					<template slot="content" style="padding: 5px 10px">
						សូមពិនិត្យការទូទាត់ប្រាក់ក្នុងរយះពេល7ថ្ងៃ​ ករណី​ផុតកំណត់ក្រុមហ៊ុនយេីងខ្ញុំមិនទទូលខុសត្រូវលេីការបាត់បង់ឡេីយ។
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100" v-if="loaded">
				<stats-card data-background-color="orange">
					<template slot="content" style="padding: 5px 10px">
						<table style="width: 100%">
							<tr>
								<td>ចំនួនកំពុងដឹក</td>
								<td style="width: 20px">:</td>
								<td> {{total_delivering}} កញ្ចប់</td>
							</tr>
							<tr>
								<td>ចំនួនដឹកជោគជ័យ</td>
								<td>:</td>
								<td>{{total_delivered}} កញ្ចប់</td>
							</tr>
							<tr>
								<td>ចំនួនបានត្រឡប់</td>
								<td>:</td>
								<td>{{total_return}} កញ្ចប់</td>
							</tr>
							<tr>
								<td>ចំនួនកញ្ចប់សរុប</td>
								<td>:</td>
								<td>{{total_package}} កញ្ចប់</td>
							</tr>
							<tr>
								<td>ទឹកប្រាក់អាចទទួលបាន</td>
								<td>:</td>
								<td><b>{{config.moneylify(total_price_usd - total_fee_usd)}} និង {{config.moneylify(total_price_khr - total_fee_khr, 'khr')}}</b></td>
							</tr>
						</table>
					</template>
				</stats-card>
			</div>

			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33" v-for="pkg in packageList">
				<stats-card data-background-color="orange">
					<template slot="content" style="padding: 5px 10px">
						<p class="category">
						<table style="font-size: 13px;line-height: 16px;width: 100%">
							<tr>
								<td>លេខកូដ</td>
								<td style="width: 20px">:</td>
								<td><b>{{pkg.tracking}}</b></td>
							</tr>

							<tr>
								<td>ទីតាំង</td>
								<td>:</td>
								<td>{{pkg.location}} ({{pkg.package_type}})</td>
							</tr>
							<tr>
								<td>តម្លៃឥវ៉ាន់</td>
								<td>:</td>
								<td>{{config.moneylify(pkg.price, pkg.price_currency)}}
									(<span v-if="pkg.price == 0">ទូទាត់រួច</span>
									<span v-else>មិនទាន់ទូទាត់</span>)
								</td>
							</tr>
							<tr>
								<td>ថ្លៃដឹកជញ្ជូន</td>
								<td>:</td>
								<td v-if="pkg.fee_responsible == 'snd'">
									{{config.moneylify(pkg.fee, pkg.fee_currency)}}
									({{config.getStatus(pkg.fee_responsible)}})
								</td>
								<td v-else>
									{{config.moneylify(pkg.fee, pkg.fee_currency)}}
									({{config.getStatus(pkg.fee_responsible)}})
								</td>
							</tr>
							<tr>
								<td>អ្នកទទួល</td>
								<td>:</td>
								<td>{{pkg.receiver_phone}}</td>
							</tr>
							<tr v-if="pkg.note">
								<td>ចំណាំ</td>
								<td>:</td>
								<td><b style="color:red">{{pkg.note}}</b></td>
							</tr>
							<tr v-if="pkg.note">
								<td>លេខអ្នកដឹក</td>
								<td>:</td>
								<td>{{pkg.driver_phone}}</td>
							</tr>
							<tr>
								<td>កាលបរិច្ឆេទ</td>
								<td>:</td>
								<td>{{config.datelify(pkg.created_date)}}</td>
							</tr>
						</table>

						</p>
						<div style="display: flex; flex-direction: row; justify-content: space-between;margin-top: 5px">
							<p>

							</p>

							<p>
								<a v-if="pkg.status != 'ndv'" :href="'tel:' + pkg.driver_phone"><span style="text-align: right;margin-right:8px;cursor: pointer;" class="gray">ទាក់ទងអ្នកដឹក</span></a>
								<span style="text-align: right;" class="late" v-if="pkg.status == 'wdv'">រង់ចាំអ្នកដឹកជញ្ជូន</span>
								<span style="text-align: right;" class="neutral" v-if="pkg.status == 'dvr'">កំពុងដឹកជញ្ជូន</span>
								<span style="text-align: right;" class="return" v-if="pkg.status == 'rtn'">បានត្រឡប់</span>
								<span style="text-align: right;" class="active" v-if="pkg.status == 'dlv'">បានដល់អតិថិជន</span>
							</p>
						</div>
					</template>
				</stats-card>
			</div>
		</div>
	</div>
</template>

<script>
	import StatsCard from '@/components/Cards/StatsCard'

	export default {
		components: {
			StatsCard
		},
		data() {
			return {
				loaded: false,
				packageList: [],
			}
		},

		created() {
			this.getPackage();
		},
		computed: {
			total_price_usd() {
				let total = 0;
				for(let i =0; i < this.packageList.length; i++) {
					if(this.packageList[i].status == 'dlv' && this.packageList[i].price_currency == 'usd') {
						total = total + this.packageList[i].price;
					}
				}
				return total;
			},
			total_price_khr() {
				let total = 0;
				for(let i =0; i < this.packageList.length; i++) {
					if(this.packageList[i].status == 'dlv' && this.packageList[i].price_currency == 'khr') {
						total = total + this.packageList[i].price;
					}
				}
				return total;
			},

			total_fee_usd() {
				let total = 0;
				for(let i =0; i < this.packageList.length; i++) {
					if(this.packageList[i].status == 'dlv' && this.packageList[i].fee_currency == 'usd' && this.packageList[i].fee_responsible == 'snd') {
						total = total + this.packageList[i].fee;
					}
				}
				return total;
			},
			total_fee_khr() {
				let total = 0;
				for(let i =0; i < this.packageList.length; i++) {
					if(this.packageList[i].status == 'dlv' && this.packageList[i].fee_currency == 'khr') {
						total = total + this.packageList[i].fee;
					}
				}
				return total;
			},

			total_package() {
				return this.packageList.length
			},
			total_return() {
				let total = 0;
				for(let i =0; i < this.packageList.length; i++) {
					if(this.packageList[i].status == 'rtn') total = total + 1;
				}
				return total;
			},
			total_delivered() {
				let total = 0;
				for(let i =0; i < this.packageList.length; i++) {
					if(this.packageList[i].status == 'dlv') total = total + 1;
				}
				return total;
			},
			total_delivering() {
				let total = 0;
				for(let i =0; i < this.packageList.length; i++) {
					if(this.packageList[i].status != 'dlv' && this.packageList[i].status != 'rtn') total = total + 1;
				}
				return total;
			}
		},
		methods: {
			// call(phone) {
			// },
			getPackage() {
				this.loaded = false;
				this.$http.get(this.config.api + "/client/package/get/list/0").then(data => {
					this.packageList = data.body.data
					this.loaded = true
				});
			},

			goScan() {
				this.$router.push("/scan");
			},
			deliver(hash_id = "") {
				if (this.deliverHash == "" && String(hash_id).length > 0) {
					this.deliverHash = hash_id
					this.deliverActive = true;
				} else {
					this.$http.post(this.config.api + "/admin/driver/deliver", {
						hash_id: this.deliverHash
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "បានបញ្ចប់",
								icon: 'done',
								type: 'success'
							})
							this.getPackage();
						}
					})
				}

			},
			onCancel() {
				this.deliverHash = ""
				this.deliverActive = false
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue